import { render, staticRenderFns } from "./ModalFranchiseNotifications.vue?vue&type=template&id=b4e52c3c&scoped=true&"
import script from "./ModalFranchiseNotifications.vue?vue&type=script&lang=js&"
export * from "./ModalFranchiseNotifications.vue?vue&type=script&lang=js&"
import style0 from "./ModalFranchiseNotifications.vue?vue&type=style&index=0&id=b4e52c3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e52c3c",
  null
  
)

export default component.exports